import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { useEffect, useRef, useState } from "react";

export function useSuperAdmin() {
  const { user } = useAuth();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const userId = user?.id;
  const checkedUserIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!userId) {
      setIsSuperAdmin(false);
      setLoading(false);
      checkedUserIdRef.current = null;
      return;
    }
    // Skip re-check if we already verified this user
    if (checkedUserIdRef.current === userId) return;

    const checkAdmin = async () => {
      setLoading(true);
      try {
        const { data } = await supabase.rpc("is_superadmin", { _user_id: userId });
        setIsSuperAdmin(!!data);
        checkedUserIdRef.current = userId;
      } catch {
        setIsSuperAdmin(false);
      } finally {
        setLoading(false);
      }
    };
    checkAdmin();
  }, [userId]);
  
  return {
    isSuperAdmin,
    loading,
  };
}
